import { render, staticRenderFns } from "./MindsetSvg.vue?vue&type=template&id=77ef81fa&"
import script from "./MindsetSvg.vue?vue&type=script&lang=ts&"
export * from "./MindsetSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports